import type { PayoutContext } from './payout-context.model';

export function generatePayoutContextObjects(
  config: GeneratePayoutContextOptions,
): readonly PayoutContext[] {
  return [
    {
      id: config.id ?? '1111',
      identityVerified: config.identityVerified ?? true,
      phoneVerified: config.phoneVerified ?? true,
      showMembershipBanner: config.showMembershipBanner ?? true,
      timestamp2faInMs: config.timestamp2faInMs ?? 123,
      isLimited: config.isLimited ?? false,
      isFullRestricted: config.isFullRestricted ?? false,
      emailVerified: config.emailVerified ?? true,
      isRequiredToPhoneReverify: config.isRequiredToPhoneReverify ?? false,
      isForceKycVerify: config.isForceKycVerify ?? false,
      negativeBalanceSuspended: config.negativeBalanceSuspended ?? false,
    },
  ];
}

export interface GeneratePayoutContextOptions {
  readonly id?: string;
  readonly identityVerified?: boolean;
  readonly phoneVerified?: boolean;
  readonly showMembershipBanner?: boolean;
  readonly timestamp2faInMs?: number;
  readonly isLimited?: boolean;
  readonly isFullRestricted?: boolean;
  readonly emailVerified?: boolean;
  readonly isRequiredToPhoneReverify?: boolean;
  readonly isForceKycVerify?: boolean;
  readonly negativeBalanceSuspended?: boolean;
}
